export default __webpack_public_path__ + "static/api-04f8e568628f0413372bada64e456e1c.png";